import { RouteObject } from 'react-router-dom';

import { Assignment } from '@/pages/Fleet';

import {
  NewAssignment,
  EditAssignment,
  TemplatesPage,
  NewTemplate,
  EditTemplate,
  StartEndWork
} from '@/pages/Fleet/Assignment/pages';
import CalendarAssignmentsPage from '../pages/Templates/CalendarAssignmentsPage';

export const AssignmentsRoutes: RouteObject[] = [
  {
    path: 'assignment',
    element: <Assignment />,
  },
  {
    path: 'assignment/new',
    element: <NewAssignment />,
  },
  {
    path: 'assignment/:id/edit',
    element: <EditAssignment />,
  },
  {
    path: 'assignment/plantillas',
    element: <TemplatesPage />,
  },
  {
    path: 'assignment/plantillas/new',
    element: <NewTemplate />,
  },
  {
    path: 'assignment/plantillas/calendar',
    element: <CalendarAssignmentsPage />,
  },
  {
    path: 'assignment/plantillas/:id/edit',
    element: <EditTemplate />,
  },
  {
    path: 'assignment/start-end-work',
    element: <StartEndWork />,
  },
];
